// extracted by mini-css-extract-plugin
module.exports = {"modal":"index_modal__ZWBW5","confirmButton":"index_confirmButton__gdCyj","canClick":"index_canClick__iWYRc"};